<div class="d-flex flex-column h-100 signature-widget">
  @if (item?.templateOptions?.label) {
    <label class="label-preview-title">
      {{ item.templateOptions.label }} @if (item.templateOptions.required) {
      <span>*</span>
    }
  </label>
}

<!-- Uploaded signature: read only image plus Clear -->
@if (isCommitted) {
  <div class="d-flex flex-column flex-grow-1 signature-body">
    <div class="signature-image-wrapper d-flex align-items-center justify-content-center">
      <img [src]="signatureControl.value | safeHtml" class="signature-image" alt="">
    </div>
    <div class="d-flex align-items-center justify-content-center signature-footer">
      <a (click)="clear()" class="fs-12 text-dark-grey font-weight-600 cursor-pointer">
        {{ 'MODALS.SIGNATURE.CLEAR' | translate }}
      </a>
    </div>
  </div>
}

<!-- Empty or pending signature: drawable pad -->
@if (!isCommitted) {
  <div class="d-flex flex-column flex-grow-1 signature-body">
    <div class="signature-pad-wrapper flex-grow-1" #padContainer>
      <ngx-signature-pad #signaturePad [options]="padOptions" (endSign)="endSign()"></ngx-signature-pad>
      @if (!isPending) {
        <div class="signature-placeholder d-flex align-items-center justify-content-center">
          <span class="fs-12">{{ 'MAIN.CONTENT.WORKFLOW.PREVIEW.SIGN-HERE' | translate }}</span>
        </div>
      }
    </div>
    <div class="d-flex align-items-center justify-content-center signature-footer">
      @if (isPending) {
        <a (click)="clear()" class="fs-12 text-dark-grey font-weight-600 cursor-pointer">
          {{ 'MODALS.SIGNATURE.CLEAR' | translate }}
        </a>
      }
    </div>
  </div>
}
</div>
